import React from "react"

import {
	Button,
	IconButton,
	Stack,
} from "@mui/material"

import { GridColDef } from "@mui/x-data-grid"

import { Trans } from "@lingui/macro"

import Icon from "@mdi/react"
import {
	mdiHeartBroken,
} from "@mdi/js"
import { Link } from "react-router-dom"

import {GridRenderCellParams} from "@mui/x-data-grid/models/params/gridCellParams";
import {AssetService} from "../../../services/asset.service";
import {ErrorResponse, RestResponse} from "@sinossi/mates-react-library";


export interface FavouriteAssetColumnInterface {
	removeCallback: (response: RestResponse<any, ErrorResponse>) => void
	onError: (response: any) => void
}

const euro = Intl.NumberFormat("it-IT", {
	style: 'currency',
	currency: 'EUR',
});


const defaultColumnDefinition: GridColDef = {
	headerName: "",
	editable: false,
	sortable: false,
	flex: 1,
	headerAlign: "left",
	align: "left",
} as GridColDef

const getTableColumns = (data: FavouriteAssetColumnInterface): GridColDef[] => {
	return [
		{
			...defaultColumnDefinition,
			field: "assetAddress",
			headerName: "Immobile",
			flex: 3,
			valueGetter: (params) => {
				return params.row.asset.address
			},
		},
		{
			...defaultColumnDefinition,
			field: "assetGla",
			headerName: "Dimensioni (mq)",
			valueGetter: (params) => {
				return params.row.asset.characteristics.gla
			},
		},
		{
			...defaultColumnDefinition,
			field: "price",
			headerName: "Prezzo",
			valueGetter: (params) => {
				return euro.format(params.row.asset.characteristics.price)
			},
		},
		{
			...defaultColumnDefinition,
			field: "contractType",
			headerName: "Tipologia contratto",
			flex: 1.5,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<Trans id = {"enums.contract-type." + params.row.asset.characteristics.contractType}>

					</Trans>
				)
			}
		},
		{
			...defaultColumnDefinition,
			field: "button",
			headerName: "",
			renderCell: (params: { row: any }) => {
				return (
					<Stack direction="row" alignItems="center">
						{/*<IconButton*/}
						{/*	disableFocusRipple*/}
						{/*	disableRipple>*/}
						{/*	<Icon path={mdiEmail} size="22px" />*/}
						{/*</IconButton>*/}
						<IconButton
							disableFocusRipple
							disableRipple
							onClick={() => AssetService.removeFromFavourite(params.row.asset.id, data.removeCallback, data.onError)}
						>
							<Icon path={mdiHeartBroken} size="22px" />
						</IconButton>
						<Link key={params.row.id} to={`/asset/${params.row.asset.id}`}>
							<Button
								variant="contained"
								disableElevation
								sx={{
									textTransform: 'none',
									backgroundColor: 'secondary.main',
									color: 'white',
									paddingX: 2,
									height: 28,
									ml: 2
								}}>
								<Trans id="favourite-table.view-details">
									Vedi dettagli
								</Trans>
							</Button>
						</Link>
					</Stack>
				)
			},
		},
	]
}

export default getTableColumns
